import React, { useState } from 'react';
import { X, Beer } from 'lucide-react';
import theme from '../themes';

const DrinkSelector = ({ currentDrink, onSelect, onClose }) => {
  const [customDrink, setCustomDrink] = useState('');

  const handleCustomSubmit = (e) => {
    e.preventDefault();
    if (customDrink.trim()) {
      onSelect(customDrink.trim());
      onClose();
    }
  };

  return (
    <div className="absolute inset-0 z-[3000] bg-black/80 flex items-end animate-in slide-in-from-bottom duration-300">
      <div className="w-full bg-zinc-900 rounded-t-[2rem] p-6 pb-safe border-t-4 border-brand-pink shadow-2xl">
        
        {/* Header */}
        <div className="flex justify-between items-start mb-6">
          <div className="flex flex-col gap-1.5">
            <div className="flex items-center gap-2 transform -skew-x-12 bg-black px-3 py-1 border-l-4 border-brand-teal shadow-[4px_4px_0px_var(--accent-2)] inline-flex">
              <div className="transform skew-x-12 flex items-center gap-2">
                <Beer className="text-white" size={18} />
                <h2 className="text-sm font-black text-white uppercase italic tracking-widest">SET {theme.labels.drinksLabel} TYPE</h2>
              </div>
            </div>
            
            {/* Show Current Fuel */}
            <div className="mt-2 ml-1">
              <p className="text-[9px] font-black text-zinc-500 uppercase tracking-widest mb-0.5">Current {theme.labels.drinksLabel}</p>
              <p className="text-lg font-black italic text-brand-teal uppercase tracking-tight">{currentDrink}</p>
            </div>
          </div>

          <button onClick={onClose} className="text-zinc-500 hover:text-white bg-black p-2 rounded-full border border-zinc-800">
            <X size={20}/>
          </button>
        </div>

        {/* Custom Input */}
        <form onSubmit={handleCustomSubmit} className="relative mt-2">
            <input 
                autoFocus
                type="text" 
                placeholder="E.g. Busch Light, Water, etc." 
                value={customDrink}
                onChange={(e) => setCustomDrink(e.target.value)}
                className="w-full bg-black border-2 border-zinc-700 py-4 pl-4 pr-24 text-white font-black focus:outline-none focus:border-brand-teal transition-colors placeholder:text-zinc-600 uppercase text-sm shadow-inner"
            />
            {/* Skewed Submit Button */}
            <button 
                type="submit"
                disabled={!customDrink.trim()}
                className="absolute right-2 top-2 bottom-2 bg-brand-pink text-white px-4 font-black text-[10px] uppercase disabled:opacity-30 disabled:cursor-not-allowed hover:bg-red-600 transition-colors transform -skew-x-12 shadow-[2px_2px_0px_var(--accent-2)] active:translate-y-[2px] active:shadow-none"
            >
                <span className="block transform skew-x-12 tracking-widest">{theme.labels.primaryAction}</span>
            </button>
        </form>

      </div>
    </div>
  );
};

export default DrinkSelector;
